export const couponFormData = (selectType, locationData, dutyTypeOptions, category, discountType, subscriptionPlans) => [
  {
    textField: true,
    placeholder: "Coupon ID",
    required: true,
    type: "text",
    name: "couponCode",
    label: "Coupon ID",
    star: "*",
    gridSize: 6,
    disabled: selectType === 'details' ? true : false,
  },
  {
    textField: true,
    placeholder: "Title",
    required: true,
    type: "text",
    name: "title",
    label: "Title",
    star: "*",
    gridSize: 6,
    disabled: selectType === 'details' ? true : false,
  },
  {
    placeholder: 'Category',
    required: true,
    gridSize: 6,
    type: 'text',
    name: 'category',
    label: 'Category',
    star: '*',
    countrycode: false,
    disabled: selectType === 'details' ? true : false,
    options: [
      { value: 'Individual', label: 'Individual' },
      { value: 'Flash', label: 'Flash' },
      { value: 'Referral', label: 'Referral' },
      { value: 'Subscription', label: 'Subscription' }
    ],
  },
  {
    placeholder: 'Subscription Plan',
    required: true,
    gridSize: 6,
    type: 'text',
    name: 'subscriptionPlanId',
    label: 'Subscription Plan',
    star: '*',
    countrycode: false,
    disabled: selectType === 'details' ? true : false,
    options: (subscriptionPlans || []).map(plan => ({ value: plan.id, label: plan.name })),
  },
  {
    placeholder: "City",
    required: true,
    type: "text",
    name: "city",
    label: "City",
    autoComplete: true,
    gridSize: 6,
    option: locationData || [],
    disabled: selectType === 'details' ? true : false,
  },
  {
    placeholder: 'Duty Type',
    required: true,
    gridSize: 6,
    type: 'text',
    name: 'dutyTypes',
    label: 'Duty Type',
    autoComplete: true,
    star: '*',
    option: dutyTypeOptions || [],
    disabled: selectType === 'details' ? true : false,
  },
  {
    placeholder: 'Discount Type',
    required: true,
    gridSize: 6,
    type: 'text',
    name: 'discountType',
    label: 'Type',
    star: '*',
    countrycode: false,
    disabled: selectType === 'details' ? true : false,
    options: [
      { value: 'Flat', label: 'Flat Discount' },
      { value: 'Percentage', label: 'Percentage' }
    ],
  },
  {
    textField: true,
    placeholder: "value",
    required: true,
    type: "number",
    name: "discountValue",
    label: "Flat Value",
    star: "*",
    gridSize: 6,
    disabled: selectType === 'details' ? true : false,
  },
  {
    textField: true,
    placeholder: "Minimum Booking Price",
    required: true,
    type: "number",
    name: "minBookingAmount",
    label: "Minimum Booking Price",
    star: "*",
    gridSize: 6,
    rupee: true,
    disabled: selectType === 'details' ? true : false,
  },
  {
    textField: true,
    placeholder: "Maximum Discount value",
    required: true,
    type: "number",
    name: "maxDiscountValue",
    label: "Maximum Discount value",
    star: "*",
    gridSize: 6,
    rupee: true,
    disabled: selectType === 'details' ? true : false,
  },
  {
    dateRangePicker: true,
    placeholder: "Duration",
    required: true,
    name: "duration",
    label: "Duration",
    star: "*",
    gridSize: 6,
    disabled: selectType === 'details' ? true : false,
  },
  {
    textField: true,
    placeholder: "Per user usage limit",
    required: true,
    type: "number",
    name: "individualUsageLimit",
    label: "Per user usage limit",
    star: "*",
    gridSize: 6,
    disabled: selectType === 'details' ? true : false,
  },
  {
    textField: true,
    placeholder: "Overall usage limit",
    required: true,
    type: "number",
    name: "overallUsageLimit",
    label: "Overall usage limit",
    star: "*",
    gridSize: 6,
    disabled: selectType === 'details' ? true : false,
  },
  {
    quill: true,
    placeholder: "Description",
    required: true,
    type: "textarea",
    name: "description",
    label: "Description",
    gridSize: 12,
    disabled: selectType === 'details' ? true : false,
  },
  {
    quill: true,
    placeholder: "Terms & Conditions",
    required: true,
    type: "textarea",
    name: "terms_conditions",
    label: "Terms & Conditions",
    gridSize: 12,
    disabled: selectType === 'details' ? true : false,
  },
  {
    fileUpload: true,
    required: false,
    type: 'text',
    name: "couponImage",
    gridSize: 6,
    placeholder: "Upload image",
    label: "Coupon Image",
    disabled: selectType === 'details' ? true : false,
  },
  // Banner fields - Always visible
  {
    checkbox: true,
    required: false,
    type: "checkbox",
    name: "showAsBanner",
    label: "Show as Banner",
    gridSize: 6,
    disabled: selectType === 'details' ? true : false,
    alignCenter: true,
  },
  // {
  //   placeholder: 'Banner Priority',
  //   required: false,
  //   gridSize: 6,
  //   type: 'text',
  //   name: 'bannerPriority',
  //   label: 'Banner Priority',
  //   star: '*',
  //   countrycode: false,
  //   disabled: selectType === 'details' ? true : false,
  //   options: [
  //     { value: '1', label: '1' },
  //     { value: '2', label: '2' },
  //     { value: '3', label: '3' },
  //     { value: '4', label: '4' },
  //     { value: '5', label: '5' }
  //   ],
  // }
];



// Updated user options
export const userOption = (employeeList) => {
  const users = {
    radio: true,
    type: 'radio',
    name: 'isNewUser',
    label: 'Users ',
    required: true,
    gridSize: 6,
    disabled: false,
    radio: [
      {
        value: 'existingUser',
        label: 'Existing user',
      },
      {
        value: 'isNewUser',
        label: 'New User',
      },
    ],
  };

  const csvFile = {
    csvFileUpload: true,
    required: true,
    type: 'csvFile',
    name: "CsvFile",
    label: "CSV File",
    gridSize: 6,
    placeholder: "Upload CSV File",
    disabled: false,
  }

  return { users, csvFile };
};

export const referralOption = () => {
  const referralType = {
    radio: true,
    type: 'radio',
    name: 'referralType',
    label: 'Referral Type',
    required: true,
    gridSize: 6,
    disabled: false,
    radio: [
      {
        value: 'referee',
        label: 'Referee',
      },
      {
        value: 'referrer',
        label: 'Referrer',
      },
    ],
  };

  return { referralType };
};

export const flatoptions = (selectType) => {
  const flatValue = {
    textField: true,
    placeholder: "value",
    required: true,
    type: "number",
    name: "discountValue",
    label: "Flat Value",
    star: "*",
    gridSize: 6,
    disabled: selectType === 'details' ? true : false,
  };

  const percentageValue = {
    textField: true,
    placeholder: "value in percentage",
    required: true,
    type: "number",
    name: "perventageValue",
    label: "Percentage Value",
    star: "*",
    gridSize: 6,
    disabled: selectType === 'details' ? true : false,
    percentage: true
  };

  const maxBookingPrice = {
    textField: true,
    placeholder: "Maximum Discount value",
    required: true,
    type: "number",
    name: "maxDiscountValue",
    label: "Maximum Discount value",
    star: "*",
    gridSize: 6,
    rupee: true,
    disabled: selectType === 'details' ? true : false,
  };

  return { flatValue, percentageValue, maxBookingPrice };
};